<template>
    <diaLog tit="实名购票充值提醒" ref="dialog" width="500px" @handleClose="handleClose" :footerShowState="false">
        <div>开启“实名购票”需要调用第三方接口进行验证，收费按 0.2元/条计算，请扫码联系舞匣负责人进行充值。</div>
        <img class="img" src="https://dance-box.oss-cn-shanghai.aliyuncs.com/2020/12/23/1608729783827501.png" alt="">
        <el-button type="primary" class="btn" @click="handleClose">我知道了</el-button>
    </diaLog>
</template>

<script>
import diaLog from '@/components/diaLog'
export default {
    components: { diaLog },
    methods: {
        handleClose() {
            this.$emit('topUpTipclose')
        }
    },
}
</script>

<style lang="scss" scoped>
.img{
    width: 150px;
    height: 150px;
    margin: 20px auto;
    display: block;
}
.btn{
    margin: 0 auto;
    display: block;
}
</style>
